import * as z from "zod";
import {VisitHistorySearchResModel} from "./VisitHistorySearchResModel";

const schema = z.object({
	content: z.array(VisitHistorySearchResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountVisitHistoryResModel = {schema, model};
export type ITaxAccountVisitHistoryResModel = z.infer<typeof TaxAccountVisitHistoryResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_VISIT_HISTORY_RES: ITaxAccountVisitHistoryResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
